import React, { useState } from 'react';
import { useTable } from 'react-table';
import ReactModal from 'react-modal';

function CollegeAllEditUniversities() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedUniversity, setSelectedUniversity] = useState(null);

  // Sample data for universities
  const universities = [
    {
      id: 1,
      name: 'Harvard University',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Harvard_University_logo.svg/1024px-Harvard_University_logo.svg.png',
      about: 'Harvard University is a private Ivy League research university in Cambridge, Massachusetts.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/5/56/Harvard_University_logo.svg',
      url: 'https://www.harvard.edu',
    },
    {
      id: 2,
      name: 'Stanford University',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/a1/Stanford_University_logo.svg',
      about: 'Stanford University is a private research university located in Stanford, California.',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a1/Stanford_University_logo.svg',
      url: 'https://www.stanford.edu',
    },
  ];

  // Define columns for the DataTable
  const columns = React.useMemo(
    () => [
      {
        Header: 'University Name',
        accessor: 'name', // key to access the name of the university
      },
      {
        Header: 'Logo',
        accessor: 'logo',
        Cell: ({ value }) => <img src={value} alt="University Logo" style={{ width: '50px', height: '50px' }} />,
      },
      {
        Header: 'Image',
        accessor: 'imageUrl',
        Cell: ({ value }) => <img src={value} alt="University" style={{ width: '50px', height: '50px' }} />,
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: ({ row }) => (
          <button
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            onClick={() => handleEdit(row.original)}
          >
            Edit
          </button>
        ),
      },
    ],
    []
  );

  // Table initialization with react-table
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: universities,
  });

  // Handle the edit action and open the modal
  const handleEdit = (university) => {
    setSelectedUniversity(university);
    setModalIsOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedUniversity(null);
  };

  // Modal content for editing the university
  const renderEditModal = () => (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          padding: '20px',
          maxWidth: '600px',
          margin: '0 auto',
          borderRadius: '8px',
          border: '1px solid #ccc',
          backgroundColor: '#fff',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      <h2>Edit University</h2>
      {selectedUniversity && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label>Name: </label>
            <input
              type="text"
              value={selectedUniversity.name}
              onChange={(e) => setSelectedUniversity({ ...selectedUniversity, name: e.target.value })}
              style={{
                padding: '8px',
                width: '100%',
                borderRadius: '4px',
                border: '1px solid #ccc',
                marginBottom: '10px',
              }}
            />
          </div>
          <div>
            <label>About: </label>
            <textarea
              value={selectedUniversity.about}
              onChange={(e) => setSelectedUniversity({ ...selectedUniversity, about: e.target.value })}
              style={{
                padding: '8px',
                width: '100%',
                borderRadius: '4px',
                border: '1px solid #ccc',
                marginBottom: '10px',
                resize: 'vertical',
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <div style={{ flex: 1 }}>
              <label>URL: </label>
              <input
                type="url"
                value={selectedUniversity.url}
                onChange={(e) => setSelectedUniversity({ ...selectedUniversity, url: e.target.value })}
                style={{
                  padding: '8px',
                  width: '100%',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  marginBottom: '10px',
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label>Logo URL: </label>
              <input
                type="url"
                value={selectedUniversity.logo}
                onChange={(e) => setSelectedUniversity({ ...selectedUniversity, logo: e.target.value })}
                style={{
                  padding: '8px',
                  width: '100%',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  marginBottom: '10px',
                }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              onClick={closeModal}
              style={{
                padding: '8px 16px',
                backgroundColor: '#f44336',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                alert('University details saved!');
                closeModal();
              }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#4CAF50',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </ReactModal>
  );

  return (
    <div className="collegealledit" style={{ padding: '20px' }}>
      <h1 style={{ fontSize: '2em', marginBottom: '20px' }}>University List</h1>
      <table {...getTableProps()} style={{ width: '100%', borderCollapse: 'collapse' }} border="1">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} style={{ padding: '10px', backgroundColor: '#f4f4f4' }}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} style={{ textAlign: 'center' }}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()} style={{ padding: '10px' }}>
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {renderEditModal()}
    </div>
  );
}

export default CollegeAllEditUniversities;
